import React from 'react'
import { Route, Switch } from 'react-router-dom'

import CampaignMemberListLayout from 'layouts/campaign/CampaignMemberListLayout'
import MyTaskCalendarLayout from 'layouts/calendar/MyCalendarLayout'

import RoutineListLayout from 'layouts/routine/RoutineListLayout'
import CreateRoutineLayout from 'layouts/routine/CreateRoutineLayout'
import UpdateRoutineLayout from 'layouts/routine/UpdateRoutineLayout'

import LoginLayout from 'layouts/login/LoginLayout'
import SignupLayout from 'layouts/signup/SignupLayout'
import CompanyMemberSignupLayout from 'layouts/signup/CompanyMemberSignupLayout'
import PasswordResetLayout from 'layouts/password/PasswordResetLayout'
import PasswordResetRequestLayout from 'layouts/password/PasswordResetRequestLayout'
import SocialLoginLayout from 'layouts/login/SocialLoginLayout'

import FriendListLayout from 'layouts/friend/FriendListLayout'

import CreateGroupProjectLayout from 'layouts/group/CreateGroupProjectLayout'
import UpdateGroupProjectLayout from 'layouts/group/UpdateGroupProjectLayout'

import MatchingSurveyLayout from 'layouts/matching/MatchingSurveyLayout'
import CreateMatchingRoomLayout from 'layouts/matching/CreateMatchingRoomLayout'
import UpdateMatchingRoomLayout from 'layouts/matching/UpdateMatchingRoomLayout'
import MatchingRoomLayout from 'layouts/matching/MatchingRoomLayout'

import MyPageProjectsListLayout from 'layouts/mypage/MyPageProjectsListLayout'
import PolicyListLayout from 'layouts/mypage/PolicyListLayout'
import PrivatePolicyLayout from 'layouts/mypage/PrivatePolicyLayout'
import TermsAndConditionsLayout from 'layouts/mypage/TermsAndConditionsLayout'
import AccountDeleteLayout from 'layouts/withdrawal/AccountDeleteLayout'
import WritePersonalLayout from 'layouts/personal/WritePersonalLayout'
import BusinessInfoLayout from 'layouts/mypage/BusinessInfoLayout'

import GroupDetailLayout from 'layouts/group/GroupDetailLayout'

import TaskDetailLayout from 'layouts/feed/TaskDetailLayout'
//tutorial
import TutorialLayout from 'layouts/tutorial/TutorialLayout'
import MatchingTutorialLayout from 'layouts/tutorial/MatchingTutorialLayout'
import ChristmasMainLayout from 'layouts/christmas/ChristmasMainLayout'
import PointLayout from 'layouts/mypage/PointLayout'
import PointUse from 'layouts/mypage/PointLayout/PointUse'
import PointHistoryLayout from 'layouts/mypage/PointHistoryLayout'
import PointPolicyLayout from 'layouts/mypage/PointPolicyLayout'

import Campaign from 'pages/CampaignPage'
import CommunityPostEdit from 'components/containers/community/CommunityPostEdit'
import CampaignJoinLayout from 'layouts/campaign/CampaignJoinLayout'

import ProcessApproveOrder from 'components/containers/commerce/order/ProcessApproveOrder'
import ProcessDenyOrderLayout from 'layouts/commerce/order/ProcessDenyOrderLayout'
import ProductDetailLayout from 'layouts/commerce/product/ProductDetailLayout'
import CommerceTutorialLayout from 'layouts/commerce/CommerceTutorialLayout'
import OrderInvoiceLayout from 'layouts/commerce/order/OrderInvoiceLayout'
import OrderDetailLayout from 'layouts/commerce/order/OrderDetailLayout'
import OrderHistoryLayout from 'layouts/commerce/order/OrderHistoryLayout'
import CommnercePaybackLayout from 'layouts/commerce/CommercePaybackLayout'

import MotibellLandingLayout from 'layouts/motibell/MotibellLandingLayout'
import MotibellDetailLayout from 'layouts/motibell/MotibellDetailLayout'

import TestLayout from 'layouts/test/TestLayout'
import PaymentTest from 'layouts/test/PaymentTest'
import CookieTest from 'layouts/test/CookieTest'

import SolMarker from 'components/containers/user/shinhan/SolMarker'
import CharmdenEventPage from 'pages/CharmdenEventPage'
export default function EmptyLayout(props) {
  return (
    <>
      <Switch>
        <Route exact path="/campaign/member/list" component={CampaignMemberListLayout} />
        <Route
          exact
          path="/campaign/community/post/:postNo/edit"
          render={({ match }) => (
            <CommunityPostEdit postNo={match['params']['postNo']} type="campaign" />
          )}
        />
        <Route
          exact
          path="/group/community/post/:postNo/edit"
          render={({ match }) => (
            <CommunityPostEdit postNo={match['params']['postNo']} type="group" />
          )}
        />
        <Route
          exact
          path="/campaign/:campaignNo/join"
          render={({ match }) => <CampaignJoinLayout campaignNo={match.params.campaignNo} />}
        />
        <Route path="/campaign/:id" component={Campaign} />
        <Route exact path="/christmas" component={ChristmasMainLayout} />

        <Route exact path="/routine/list" component={RoutineListLayout} />
        <Route exact path="/routine/create" component={CreateRoutineLayout} />
        <Route exact path="/routine/:routine_no/update" component={UpdateRoutineLayout} />

        <Route exact path="/friend" component={FriendListLayout} />
        <Route
          exact
          path="/task/:id"
          render={({ match }) => <TaskDetailLayout params={match['params']} />}
        />

        <Route exact path="/mypage/projects/list" component={MyPageProjectsListLayout} />
        <Route exact path="/mypage/private_policy" component={PrivatePolicyLayout} />
        <Route exact path="/mypage/business_info" component={BusinessInfoLayout} />
        <Route exact path="/mypage/terms_and_conditions" component={TermsAndConditionsLayout} />
        <Route exact path="/mypage/policy/list" component={PolicyListLayout} />
        <Route exact path="/mypage/point" component={PointLayout} />
        <Route exact path="/mypage/point/use" component={PointUse} />
        <Route exact path="/mypage/point/history" component={PointHistoryLayout} />
        <Route exact path="/mypage/point/policy" component={PointPolicyLayout} />

        <Route exact path="/matching/survey" component={MatchingSurveyLayout} />
        <Route exact path="/matching/room/create" component={CreateMatchingRoomLayout} />
        <Route exact path="/matching/room/:room_no" component={MatchingRoomLayout} />
        <Route exact path="/matching/room/:room_no/update" component={UpdateMatchingRoomLayout} />

        <Route exact path="/calendar" component={MyTaskCalendarLayout} />
        <Route exact path="/calendar/date/:date" component={MyTaskCalendarLayout} />

        <Route exact path="/tutorial" component={TutorialLayout} />
        <Route exact path="/tutorial/matching" component={MatchingTutorialLayout} />

        <Route path="/group/:group_no/project/create" component={CreateGroupProjectLayout} />
        <Route path="/group/project/:project_no/update" component={UpdateGroupProjectLayout} />
        <Route path="/group/:group_no" component={GroupDetailLayout} />

        <Route exact path="/login" component={LoginLayout} />
        <Route exact path="/social" component={SocialLoginLayout} />
        <Route exact path="/signup" component={SignupLayout} />
        <Route exact path="/signup/company" component={CompanyMemberSignupLayout} />
        <Route exact path="/account/delete" component={AccountDeleteLayout} />
        <Route exact path="/write/personal" component={WritePersonalLayout} />

        <Route exact path="/motishop/tutorial" component={CommerceTutorialLayout} />
        <Route
          exact
          path="/motishop/product/:productNo"
          render={({ match }) => (
            <ProductDetailLayout productNo={match.params.productNo} currNavTab={'info'} />
          )}
        />
        <Route
          exact
          path="/motishop/product/:productNo/info"
          render={({ match }) => (
            <ProductDetailLayout productNo={match.params.productNo} currNavTab={'info'} />
          )}
        />
        <Route
          exact
          path="/motishop/product/:productNo/achievement"
          render={({ match }) => (
            <ProductDetailLayout productNo={match.params.productNo} currNavTab={'achievement'} />
          )}
        />
        <Route exact path="/motishop/order" component={OrderHistoryLayout} />
        <Route exact path="/motishop/order/:orderNo/approve" component={ProcessApproveOrder} />
        <Route exact path="/motishop/order/:orderNo/deny" component={ProcessDenyOrderLayout} />
        <Route
          exact
          path="/motishop/order/:orderNo/invoice"
          render={({ match: { params } }) => <OrderInvoiceLayout orderNo={params.orderNo} />}
        />
        <Route
          exact
          path="/motishop/order/:orderNo/detail"
          render={({ match: { params } }) => <OrderDetailLayout orderNo={params.orderNo} />}
        />
        <Route exact path="/motishop/payback" component={CommnercePaybackLayout} />

        <Route exact path="/motibell/:motibellNo/landing" component={MotibellLandingLayout} />
        <Route exact path="/motibell/:motibellNo" component={MotibellDetailLayout} />

        <Route exact path="/password" component={PasswordResetRequestLayout} />
        <Route exact path="/password/reset" component={PasswordResetLayout} />
        <Route exact path="/test" component={TestLayout} />
        <Route exact path="/test/payment" component={PaymentTest} />
        <Route exact path="/test/cookie" component={CookieTest} />

        <Route exact path="/event/newyear" component={CharmdenEventPage} />

        <Route exact path="/users/shinhan/sol" component={SolMarker} />
      </Switch>
    </>
  )
}
